import AddToModalContainer from './add_to_modal_container';

const AddToModal = AddToModalContainer;

export default AddToModal;
